//Ambiente productivo
export const serverUrl = "https://carp-qa.encendermedia.com/api";
export const usuariosUrl = "https://carp-qa.encendermedia.com/usuarios";
export const imgUrl = "https://carp-qa.encendermedia.com/public/img/medios";   

//Ambiente local (levantar backend con docker)
/* export const serverUrl = "http://localhost:8080/api";
export const usuariosUrl = "http://localhost:8080/usuarios";
export const imgUrl = "http://localhost:8080/public/img/medios"; */

//Ambiente DEV.
/* export const serverUrl = "https://carp.encender-dev.online/api";
export const usuariosUrl = "https://carp.encender-dev.online/usuarios";
export const imgUrl = "https://carp.encender-dev.online/public/img/medios";  */
